export const classes = {
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    pointerEvents: 'none',
    '& * .MuiTypography-root': {
      fontFamily: 'Source Sans Pro'
    },
    '& li': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  container: {
    position: 'relative',
    padding: '42px 40px',
    background: '#fff',
    borderRadius: '6px',
    maxWidth: '774px',
    pointerEvents: 'auto',
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '40px',
    width: '100%',
    columnGap: '40px',
    '& a': {
      '&:hover': {
        textDecoration: 'none'
      }
    },
    '& button': {
      outline: 'none'
    }
  },
  buttonRedLight: {
    color: '#E37D7A',
    fontFamily: 'Source Sans Pro',
    textTransform: 'capitalize',
    fontWeight: 700,
    fontSize: '14px',
    textDecoration: 'underline',
    backgroundColor: '#ffffff',
    '&:hover': {
      color: '#d74742',
      backgroundColor: '#ffffff'
    }
  },
  requestButton: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 700,
    textTransform: 'none',
    color: '#FFFFFF',
    backgroundColor: '#5BC4BF',
    borderRadius: '8px',
    boxShadow: 'none',
    minWidth: '110px',
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#4da8a4',
      boxShadow: 'none'
    }
  },
  closeIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    cursor: 'pointer',
    color: '#DDDDDD'
  }
};
